module.exports = "/assets/data/45aae1aca0f68a62ce222160c83bd99e-CH1.data.json";